import React from "react";
import "./ScienceLabs.css";
import Navbar from "../../Navbar/Navbar";
import Footer from "../../Footer/Footer";

const scienceLabsData = [
  {
  
    image: "/campuslife/sciencelab/slab-1.JPG",
  },
  {
   
    image: "/campuslife/sciencelab/slab-2.JPG",
  },
  {
   
    image: "/campuslife/sciencelab/slab-3.JPG",
  },
  {
   
    image: "/campuslife/sciencelab/slab-4.JPG",
  },
  {
   
    image: "/campuslife/sciencelab/slab-5.JPG",
  },
  {
   
    image: "/campuslife/sciencelab/slab-6.JPG",
  },
  {
   
    image: "/campuslife/sciencelab/slab-7.JPG",
  },
  {
   
    image: "/campuslife/sciencelab/slab-8.JPG",
  },
  {
   
    image: "/campuslife/sciencelab/slab-9.JPG",
  },
  {
   
    image: "/campuslife/sciencelab/slab-10.JPG",
  },
  {
   
    image: "/campuslife/sciencelab/slab-11.JPG",
  },
  {
   
    image: "/campuslife/sciencelab/slab-12.JPG",
  }
  
];

const ScienceLabs = () => {
  return (
    <>
    <Navbar/>
    <div className="sciencelabs-page">
      {/* Banner */}
      <div className="sciencelabs-banner">
        <img
          src="/campuslife/sciencelab/slab-2.JPG"
          alt="Science Laboratories"
        />
        <div className="banner-overlay">
          <h1>Science Laboratories</h1>
          <p>Experimental Learning & Research Excellence</p>
        </div>
      </div>

      {/* About */}
      <section className="sciencelabs-about">
        <h2>About Science Labs</h2>
        <p>
          The University Science Laboratories are well-equipped to support
          experimental learning and interdisciplinary research across Physics,
          Chemistry, Mechanical Sciences, Botany, Zoology, Biotechnology and
          Electronics. These labs enable students to gain practical exposure
          aligned with academic curricula and research advancements.
        </p>
      </section>

      {/* Gallery */}
      <section className="sciencelabs-gallery-section">
        <div className="sciencelabs-gallery">
          {scienceLabsData.map((lab, index) => (
            <div className="lab-card" key={index}>
              <img src={lab.image} alt={lab.title} />
              {/* <div className="lab-overlay">
                <h3>{lab.title}</h3>
              </div> */}
            </div>
          ))}
        </div>
      </section>
    </div>
    <Footer />
    </>
  );
};

export default ScienceLabs;
